// ThankYouScreen.js
import React from 'react';
import { motion } from 'framer-motion';
import '../styles/App.scss';
import '../styles/ThankYouScreen.scss';
import thankYou from '../assets/images/thank_you.jpg';

function ThankYouScreen() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { delay: 0.3, duration: 0.6 } }
  };

  const imageVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { delay: 0.5, duration: 0.6 } }
  };

  return (
    <motion.div
      className="thank-you-screen text-center"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <motion.img
        src={thankYou}
        className="max-w-[80%] border-b mb-5 mx-auto"
        variants={imageVariants}
      />
      {window?.config?.data?.agentsNotAvailableMessage ||
        'Thank you for reaching us! We will get back to you very soon.'}
    </motion.div>
  );
}

export default ThankYouScreen;
